/* Broszio homepage behavior: carousels, mouse drag, weekly countdown, active pill.
   Add-to-cart is handled by the theme's native AJAX cart (data-action="add-to-cart"). */
(function () {
  function init(root) {
    if (!root || root.dataset.bzInit) return;
    root.dataset.bzInit = '1';

    /* ---- carousel arrows ---- */
    root.querySelectorAll('.bz-railnav').forEach(function (navEl) {
      var section = navEl.closest('.bz-aisle, .bz-offers, .bz-showcase');
      var rail = section && section.querySelector('.bz-rail');
      if (!rail) return;
      var btns = navEl.querySelectorAll('button[data-d]');
      function update() {
        if (btns[0]) btns[0].disabled = rail.scrollLeft < 8;
        if (btns[1]) btns[1].disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 8;
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          rail.scrollBy({ left: (parseInt(b.dataset.d, 10) || 1) * 300, behavior: 'smooth' });
        });
      });
      rail.addEventListener('scroll', update);
      setTimeout(update, 60);
      window.addEventListener('resize', update);
    });

    /* ---- drag-to-scroll (mouse only; touch keeps native scroll) ---- */
    root.querySelectorAll('.bz-rail').forEach(function (rail) {
      var down = false, startX = 0, startScroll = 0, moved = false, pid = null;
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startScroll = rail.scrollLeft; pid = e.pointerId;
      });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true; rail.classList.add('is-dragging');
          try { rail.setPointerCapture(pid); } catch (_) {}
        }
        if (moved) { rail.scrollLeft = startScroll - dx; e.preventDefault(); }
      });
      function end() { if (!down) return; down = false; rail.classList.remove('is-dragging'); }
      rail.addEventListener('pointerup', end);
      rail.addEventListener('pointercancel', end);
      rail.addEventListener('click', function (e) {
        if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
      }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    /* ---- weekly countdown ---- */
    root.querySelectorAll('.bz-countdown').forEach(function (cd) {
      var target;
      var raw = (cd.dataset.deadline || '').trim();
      if (raw) { var t = new Date(raw.replace(' ', 'T')); target = isNaN(t) ? null : t.getTime(); }
      if (!target) { // fall back to next Monday 00:00
        var d = new Date(); d.setHours(0, 0, 0, 0);
        var add = ((8 - d.getDay()) % 7) || 7; d.setDate(d.getDate() + add); target = d.getTime();
      }
      var D = cd.querySelector('[data-cd="d"]'), H = cd.querySelector('[data-cd="h"]'),
          M = cd.querySelector('[data-cd="m"]'), S = cd.querySelector('[data-cd="s"]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        var diff = Math.max(0, target - Date.now());
        var dd = Math.floor(diff / 864e5); diff -= dd * 864e5;
        var hh = Math.floor(diff / 36e5); diff -= hh * 36e5;
        var mm = Math.floor(diff / 6e4); diff -= mm * 6e4;
        var ss = Math.floor(diff / 1e3);
        if (D) D.textContent = dd; if (H) H.textContent = pad(hh);
        if (M) M.textContent = pad(mm); if (S) S.textContent = pad(ss);
      }
      tick(); setInterval(tick, 1000);
    });

    /* ---- favourite toggle (visual only) ---- */
    root.querySelectorAll('.bz-fav').forEach(function (f) {
      f.addEventListener('click', function () { f.classList.toggle('is-on'); });
    });

    /* ---- active pill on scroll ---- */
    var pills = Array.prototype.slice.call(root.querySelectorAll('.bz-pill'));
    if (pills[0]) pills[0].classList.add('is-active');
    var sections = root.querySelectorAll('.bz-aisle[id], .bz-showcase[id]');
    if ('IntersectionObserver' in window && sections.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            pills.forEach(function (p) { p.classList.toggle('is-active', p.dataset.target === e.target.id); });
          }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      sections.forEach(function (s) { io.observe(s); });
    }
  }

  function boot() { document.querySelectorAll('[data-bz-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Re-init when re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-bz-root]'); if (r) init(r);
  });
})();
